import { useSyncExternalStore } from 'react';

/**
 * Whether the wordmark's decorative motion is paused. A page-level pause control (WCAG 2.2.2) sets it;
 * every wordmark reads it, including ones that mount or restart their effects after the pause, so the
 * value is state rather than a one-off event.
 */
let paused = false;
const listeners = new Set<() => void>();

export function setLogoMotionPaused(next: boolean) {
  if (paused === next) return;
  paused = next;
  listeners.forEach((listener) => listener());
}

export const getLogoMotionPaused = () => paused;

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Server render and hydration always see "not paused"; the pause only exists after interaction. */
export function useLogoMotionPaused() {
  return useSyncExternalStore(subscribe, getLogoMotionPaused, () => false);
}
